import ContentLoader from 'react-content-loader';
import *as React from 'react';

export const PrintCombinedViewLoader  = props => {
    return(<>
  {props.count && props.count > 0 && (
                Array.from({ length: props.count }, (_, i) => (
            <ContentLoader 
            speed={2}
            width={1307}
            height={850}
            // viewBox="0 0 1000 730"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
        >
        <rect x="500" y="10" rx="8" ry="8" width="300" height="12" /> 

        <rect x="24" y="40" rx="8" ry="8" width="181" height="12" /> 
        <rect x="24" y="78" rx="8" ry="8" width="166" height="12" /> 
        <rect x="24" y="104" rx="8" ry="8" width="162" height="12" /> 
        <rect x="24" y="134" rx="8" ry="8" width="280" height="12" /> 
        <rect x="24" y="161" rx="8" ry="8" width="316" height="12" /> 
        <rect x="24" y="187" rx="8" ry="8" width="318" height="12" /> 

        <rect x="24" y="234" rx="8" ry="8" width="100" height="12" /> 
        <rect x="24" y="266" rx="8" ry="8" width="150" height="12" /> 
        <rect x="485" y="233" rx="8" ry="8" width="100" height="12" /> 
        <rect x="485" y="262" rx="8" ry="8" width="150" height="12" /> 
        <rect x="880" y="239" rx="8" ry="8" width="100" height="12" /> 
        <rect x="880" y="267" rx="8" ry="8" width="150" height="12" /> 

        <rect x="24" y="308" rx="8" ry="8" width="100" height="12" /> 
        <rect x="24" y="333" rx="8" ry="8" width="150" height="12" /> 
        <rect x="485" y="308" rx="8" ry="8" width="100" height="12" /> 
        <rect x="485" y="333" rx="8" ry="8" width="150" height="12" /> 
        <rect x="880" y="308" rx="8" ry="8" width="100" height="12" />
        <rect x="880" y="333" rx="8" ry="8" width="150" height="12" /> 

        <rect x="24" y="378" rx="8" ry="8" width="100" height="12" /> 
        <rect x="24" y="403" rx="8" ry="8" width="150" height="12" /> 
        <rect x="485" y="378" rx="8" ry="8" width="100" height="12" /> 
        <rect x="485" y="403" rx="8" ry="8" width="150" height="12" /> 
        <rect x="880" y="378" rx="8" ry="8" width="100" height="12" /> 
        <rect x="880" y="403" rx="8" ry="8" width="150" height="12" />  

        <rect x="24" y="448" rx="8" ry="8" width="100" height="12" /> 
        <rect x="24" y="473" rx="8" ry="8" width="150" height="12" /> 
        <rect x="485" y="448" rx="8" ry="8" width="100" height="12" /> 
        <rect x="485" y="473" rx="8" ry="8" width="150" height="12" /> 
        <rect x="880" y="448" rx="8" ry="8" width="100" height="12" /> 
        <rect x="880" y="473" rx="8" ry="8" width="150" height="12" /> 

        <rect x="24" y="518" rx="8" ry="8" width="100" height="12" /> 
        <rect x="24" y="543" rx="8" ry="8" width="150" height="12" /> 
        <rect x="485" y="518" rx="8" ry="8" width="100" height="12" /> 
        <rect x="485" y="543" rx="8" ry="8" width="150" height="12" /> 

        <rect x="24" y="590" rx="8" ry="8" width="150" height="12" /> 
        <rect x="24" y="625" rx="8" ry="8" width="1200" height="12" /> 
        <rect x="24" y="649" rx="8" ry="8" width="1200" height="12" /> 
        <rect x="24" y="678" rx="8" ry="8" width="1200" height="12" /> 
        </ContentLoader>    
        ))
    )}</>)
}
       
